<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>客服管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单状态：" prop="orderStatus">
              <el-select clearable size="small" v-model="listParams.orderStatus" style="width: 100%" placeholder="请选择订单状态">
                <el-option v-for="item in statusList" :label="item.title" :value="item.orderStatus" :key="item.title"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="订单分类：" prop="orderType">
              <el-select clearable size="small" v-model="listParams.orderType" style="width: 100%" placeholder="请选择订单分类">
                <el-option v-for="item in orderTypeList" :label="item.title" :value="item.orderType" :key="item.title"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="手机号：" prop="buyerMobile">
              <el-input clearable size="small" v-model="listParams.buyerMobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="领货日期：" prop="supplyDate">
              <date-picker-group v-model="listParams.supplyDate"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData(defaultPager)">查询</el-button>

              <el-button size="small" @click="resetForm('listForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" :show-pager-on-one-page="paginationShow" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"></span>
          </template>
        </el-table-column>

        <el-table-column prop="supplyDate" align="center" label="领货日期"></el-table-column>

        <el-table-column prop="orderStatusDisplay" align="center" label="订单状态"></el-table-column>

        <el-table-column prop="orderType" align="center" label="订单分类"></el-table-column>

        <el-table-column prop="orderAmount" align="center" label="支付金额"></el-table-column>

        <el-table-column prop="buyerMobile" align="center" label="手机号"></el-table-column>

        <el-table-column prop="dValueAmount" align="center" label="补差/退款金额"></el-table-column>

        <el-table-column prop="amountTotal" align="center" label="结算金额"></el-table-column>

        <el-table-column prop="paymentTime" align="center" label="支付时间"></el-table-column>

        <el-table-column prop="dValueTime" align="center" label="补差/退款时间"></el-table-column>

        <el-table-column prop="paymentType" align="center" label="支付方式"></el-table-column>

        <el-table-column align="center" label="订单详情">
          <template slot-scope="scope">
            <el-button type="text" @click="linkToDetailPage(scope.row.orderId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        orderStatus: "",
        orderType: "",
        buyerMobile: "",
        supplyDate: ["", ""],
      },
      statusList: [
        { orderStatus: "", title: "全部" },
        { orderStatus: "0", title: "已取消" },
        { orderStatus: "1", title: "待付款" },
        { orderStatus: "2", title: "待发货" },
        { orderStatus: "3", title: "待收货" },
        { orderStatus: "4", title: "待补差" },
        { orderStatus: "5", title: "待退款" },
        { orderStatus: "6", title: "退款中" },
        { orderStatus: "7", title: "已完成" },
        { orderStatus: "8", title: "交易关闭" },
        { orderStatus: "9", title: "交易过期" },
      ],
      orderTypeList: [
        { orderType: "", title: "全部" },
        { orderType: "0", title: "混合订单类型" },
        { orderType: "1", title: "供应局订单" },
        { orderType: "2", title: "场馆订单" },
        { orderType: "3", title: "补差订单" },
        { orderType: "4", title: "洗车订单" },
        { orderType: "5", title: "科技委订单" },
        { orderType: "6", title: "商城订单" },
        { orderType: "7", title: "科技委党费订单" },
      ],
      tableLoading: false,
      paginationShow: true,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      defaultPager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tempBodyParams: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.query.bodyParams) {
      const bodyParams = JSON.parse(from.query.bodyParams);
      next(vm => {
        const pager = {
          pageSize: bodyParams.pageSize,
          pageIndex: bodyParams.pageIndex,
        };
        for (const i in vm.listParams) {
          for (const j in bodyParams) {
            if (i === j) {
              vm.listParams[i] = bodyParams[j];
            }
          }
        }
        vm.$set(vm.listParams.supplyDate, 0, bodyParams.supplyStartDate);
        vm.$set(vm.listParams.supplyDate, 1, bodyParams.supplyEndDate);
        vm.paginationShow = false;
        vm.pager.pageIndex = bodyParams.pageIndex;
        vm.pager.pageSize = bodyParams.pageSize;
        vm.loadTableData(pager);
      });
    } else {
      next(vm => {
        vm.loadTableData();
      });
    }
  },
  methods: {
    /**
     * 加载列表数据
     * @param state
     */
    loadTableData(tempPager) {
      const pager = tempPager || this.pager;
      if (tempPager) {
        this.pager.pageSize = pager.pageSize;
        this.pager.pageIndex = pager.pageIndex;
      }
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: pager.pageIndex,
        pageSize: pager.pageSize,
      });
      bodyParams.supplyStartDate = bodyParams.supplyDate[0];
      bodyParams.supplyEndDate = bodyParams.supplyDate[1];
      delete bodyParams.supplyDate;
      for (const i in bodyParams) {
        if (bodyParams[i] === "" || bodyParams[i] === undefined) {
          delete bodyParams[i];
        }
      }
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/getorders/query",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tempBodyParams = Object.assign({}, bodyParams);
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.orderList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置请求表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.pager.pageIndex = 1;
      this.defaultPager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 跳转至详情页
     * @param orderId
     */
    linkToDetailPage(orderId) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: orderId,
          bodyParams: JSON.stringify(this.tempBodyParams),
        },
      });
    },
  },
};
</script>

<style scoped></style>
